import { Selection } from "../contracts"
import { EntityType, SelectionStatus } from "sbtech-sports-data-api-contracts";

/* tslint:disable:no-null-keyword */
export const emptySelection: Selection = {
    id: "",
    outcomeType: null,
    group: 0,
    name: "",
    title: "",
    betslipLine: "",
    participantMapping: "",
    displayOdds: {},
    trueOdds: 0,
    points: null,
    pointsText: "",
    tags: [""],
    metadata: {},
    isDisabled: true,
    marketId: "",
    odds: "",
    isSelectionInBetslip: false,
    entityType: EntityType.Selection,
    status: SelectionStatus.Disabled
}

export const emptySelectionPointBox: Selection = {
    id: "",
    outcomeType: null,
    group: 0,
    name: "",
    title: "",
    betslipLine: "",
    participantMapping: "",
    displayOdds: {},
    trueOdds: 0,
    points: 0,
    pointsText: "",
    tags: [""],
    metadata: {},
    isDisabled: true,
    marketId: "",
    odds: "",
    isSelectionInBetslip: false,
    entityType: EntityType.Selection,
    status: SelectionStatus.Disabled
}